import moment from 'moment'
import { InjuredState, InsuranceEntity, ManagementType, Segment } from './enums'

const checkIfDateIsBefore = (date1, date2) => {
	return moment(date1).diff(date2) < 0
}

export const shouldAllowManualIppCreation = (clinicalProcess, appointments) => {
	const admissionDate = clinicalProcess.info?.admissionDate?.tinyDateFormat
	const clinicalStatus = clinicalProcess.clinicalStatus?.value
	const injuredStateId = clinicalProcess.processInjuredState
	const managementType = clinicalProcess.info?.managementType
	const ExecutedDamageEvaluationsWithDevaluatedDischarge = appointments?.filter(
		(appointment) =>
			appointment?.medicalSpecialty?.id === 53 &&
			appointment?.status?.value === 'executed' &&
			appointment?.disability?.id === 'ACCD'
	)
	const processSegment =
		clinicalProcess?.accident?.segment?.abbreviation || ''
	const insuranceCompanyId =
		clinicalProcess.insurancePolicy?.insuranceCompany?.id

	const invalidInsuranceEntity = [
		InsuranceEntity.Caravela,
		InsuranceEntity.VictoriaVida,
		InsuranceEntity.AVUS,
		InsuranceEntity.LibertyIntegração,
		InsuranceEntity.MapfreSeguros,
		InsuranceEntity.AON,
		InsuranceEntity.Segurmet,
		InsuranceEntity.CASeguros,
		InsuranceEntity.GJM,
	].includes(insuranceCompanyId)

	const isAgeasOrOcidentalBeforeDate =
		[InsuranceEntity.Ageas, InsuranceEntity.Ocidental].includes(
			insuranceCompanyId
		) &&
		checkIfDateIsBefore(
			moment(admissionDate),
			new Date(moment('01-11-2019'))
		)

	const isLibertyBeforeDate =
		insuranceCompanyId === InsuranceEntity.Liberty &&
		checkIfDateIsBefore(admissionDate, new Date(moment('01-02-2021')))

	const clinicalStatusNotOnGoing = clinicalStatus !== 'ON_GOING'
	const invalidInjuredState = ![
		InjuredState.Accepted,
		InjuredState.Analysis,
	].includes(injuredStateId)
	const isAdministrativeProcess = clinicalProcess?.info?.adminProcess
	const isPensioner = clinicalProcess.accident?.isPensioner
	const hasExecutedDamageEvaluationsWithDevaluatedDischarge =
		ExecutedDamageEvaluationsWithDevaluatedDischarge?.length
	const isInsuranceCompanyManagementType =
		managementType === ManagementType.InsuranceCompany
	const isSportsAccident = processSegment === Segment.SportsAccident

	if (
		invalidInsuranceEntity ||
		isAgeasOrOcidentalBeforeDate ||
		isLibertyBeforeDate ||
		clinicalStatusNotOnGoing ||
		invalidInjuredState ||
		isAdministrativeProcess ||
		isPensioner ||
		hasExecutedDamageEvaluationsWithDevaluatedDischarge ||
		isInsuranceCompanyManagementType ||
		isSportsAccident
	) {
		return false
	}

	return true
}
